import React from "react";
import { RadioGroup, RadioButton } from "@adsk/alloy-react-radio-button";
import { useTranslations } from "../../utils";
import { AnalyticsEvents } from "../../shared/constants";
import {
  LabelField,
  LabelText,
  RadioInput,
  RadioInputLabelPanel,
  RadioInputPanel,
} from "./ProjectTemplateCreateSelectTypeModal.styles";
import { TemplateCreateType } from "../../shared/types";
import { FromProjectDetails } from "../../shared/components/FromProjectDetails";
export var ProjectTemplateCreateSelectTypeModal = function (_a) {
  var selectedProjectType = _a.selectedProjectType,
    setSelectedProjectType = _a.setSelectedProjectType,
    track = _a.track;
  var T = useTranslations().T;
  return React.createElement(
    RadioGroup,
    {
      "data-testid": "ProjectTemplateCreateModal.SelectType",
      value: selectedProjectType,
      name: "type",
      onChange: function (nextValue) {
        nextValue && setSelectedProjectType(nextValue);
        // Record the analytics event
        if (track && nextValue === TemplateCreateType.Blank) {
          track &&
            track(AnalyticsEvents.createTemplateModal.templateCreateTypeBlank);
        } else if (track && nextValue === TemplateCreateType.FromProject) {
          track(
            AnalyticsEvents.createTemplateModal.templateCreateTypeFromProject
          );
        }
      },
    },
    React.createElement(
      LabelField,
      null,
      React.createElement(
        RadioInputPanel,
        null,
        React.createElement(
          RadioInput,
          null,
          React.createElement(RadioButton, {
            "data-testid": "ProjectTemplateCreateModal.OptionBlankTemplate",
            value: TemplateCreateType.Blank,
          })
        )
      ),
      React.createElement(
        RadioInputLabelPanel,
        null,
        React.createElement(
          LabelText,
          null,
          T.translate("createTemplateModal.createBlank")
        )
      )
    ),
    React.createElement(
      LabelField,
      null,
      React.createElement(
        RadioInputPanel,
        null,
        React.createElement(
          RadioInput,
          null,
          React.createElement(RadioButton, {
            "data-testid": "ProjectTemplateCreateModal.OptionFromProject",
            value: TemplateCreateType.FromProject,
          })
        )
      ),
      React.createElement(
        RadioInputLabelPanel,
        null,
        React.createElement(
          LabelText,
          null,
          T.translate("createTemplateModal.createFromProject")
        ),
        React.createElement(FromProjectDetails, null)
      )
    )
  );
};
